import { render, staticRenderFns } from "./TopicoVideoS3.vue?vue&type=template&id=cbb36676&scoped=true&"
import script from "./TopicoVideoS3.vue?vue&type=script&lang=js&"
export * from "./TopicoVideoS3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb36676",
  null
  
)

export default component.exports